<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { debounce } from 'vue-debounce'
import { id as idLocale } from 'vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { VueGoodTable } from 'vue-good-table'
import { SweetModal } from 'sweet-modal-vue'
import VuePdfApp from 'vue-pdf-app'
import PaginationCustom from '@/components/table/Pagination.vue'
import appData from '@/data'
import kodeDaerah from '@/data/modules/kodeDaerah'

import 'vue-pdf-app/dist/icons/main.css'
import ProyekDetail from '@/components/oss/ProyekDetail.vue'

export default {
   name: 'IzinRba',
   components: {
      BCardCode,
      VueGoodTable,
      PaginationCustom,
      SweetModal,
      VuePdfApp,
      ProyekDetail,
      vSelect,
   },
   data() {
      return {
         pdf: '',
         loading: true,
         loadingPdf: false,
         inputSearch: true,
         isFilterOpen: false,
         filterDateLang: idLocale,
         serverParams: {
            columnFilters: {},
            sort: {
               field: '',
               type: '',
            },
            search: '',
            page: 1,
            perPage: 10,
         },
         pageLength: 10,
         pageOptions: ['10', '25', '50', '100'],
         searchTerm: '',
         columns: [
            {
               label: 'Nama Dokumen',
               field: 'dokumen',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'NIB / Nama',
               field: 'nib',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'KBLI / Sektor / Resiko',
               field: 'usaha',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Nama Usaha/ Alamat Usaha',
               field: 'alamat',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Kewenangan/Status',
               field: 'status',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Action',
               field: 'action',
               sortable: false,
               thClass: 'text-center align-middle',
            },
         ],
         filter: {
            tanggal_awal: null,
            tanggal_akhir: null,
            jenis: null,
            kewenangan: null,
            skala: null,
            resiko: null,
            status: null,
            sektor: null,
            perusahaan_daerah_id: null,
            daerah_mode: 'kecamatan',
         },
         options: {
            jenis: appData.filterOss.jenisIzinRba,
            kewenangan: appData.filterOss.kewenanganIzinRba,
            skala: appData.filterOss.skalaUsaha,
            resiko: appData.filterOss.resiko,
            status: appData.filterOss.statusIzin,
            sektor: [
               { value: null, text: '-' },
               ...Object.entries(appData.sektor).map(([value, text]) => ({ value, text })),
            ],
         },
      }
   },
   computed: {
      ...mapState({
         myData: state => state.OssIzinRba.items,
         myCount: state => state.OssIzinRba.countAll,
      }),
      jenisPerusahaan() {
         const data = appData.jenisPerusahaan
         return status => (data[status] ? data[status] : status)
      },
      skalaUsaha() {
         const data = appData.skalaUsaha
         return status => (data[status] ? data[status] : status)
      },
      statusPM() {
         const data = appData.statusPm
         return status => (data[status] ? data[status] : status)
      },
      statusResiko() {
         const data = appData.statusResiko
         return status => (data[status] ? data[status] : status)
      },
      statusNIB() {
         const data = appData.statusNib
         return status => (data[status] ? data[status] : status)
      },
      statusBadanHukum() {
         const data = appData.statusBadanHukum
         return status => (data[status] ? data[status] : status)
      },
      statusIzin() {
         const data = appData.statusIzin
         return status => (data[status] ? data[status] : status)
      },
      kewenanganIzin() {
         const data = appData.kewenanganIzin
         return kewenangan => (data[kewenangan] ? data[kewenangan] : kewenangan)
      },
      kewenanganColor() {
         return kewenangan => (kewenangan === '02'
            ? 'text-danger font-weight-bold'
            : 'text-dark font-italic')
      },
      sektorCode() {
         const data = appData.sektor
         return status => (data[status] ? data[status] : status)
      },
      optionsDaerah() {
         return kodeDaerah.map(item => ({
            value: item.kode,
            text: `${item.kode} - ${item.kecamatan} - ${item.kelurahan}`,
         }))
      },
      statusNIBVariant() {
         const data = {
            /* eslint-disable key-spacing */
            '01': 'success',
            '06': 'danger',
            /* eslint-enable key-spacing */
         }
         return status => (data[status] ? data[status] : 'primary')
      },
   },
   watch: {
      loadingPdf(val) {
         if (val) {
            this.$swal({ text: 'Loading', allowOutsideClick: false })
            this.$swal.showLoading()
         } else {
            this.$swal.close()
         }
      },
   },
   mounted() {
      this.loadItems()
   },
   methods: {
      ...mapActions({
         getData: 'OssIzinRba/getData',
         cetakIzin: 'OssIzinRba/cetakIzin',
         cetakListIzinRba: 'OssIzinRba/cetakListIzinRba',
         cetakNib: 'OssNib/cetakNib',
         runScrap: 'OssScrap/runScrap',
         runScrapDokumen: 'OssScrapIzin/runScrap',
         getNib: 'OssScrapIzin/getNib',
      }),
      ...mapMutations({
         setIdProyek: 'OssBidangUsaha/SET_ID_PROYEK',
      }),
      onCetakIzin(id) {
         this.loadingPdf = true
         this.cetakIzin(id).then(
            res => {
               const blob = new Blob([res.data])
               const objectUrl = URL.createObjectURL(blob)
               this.pdf = objectUrl

               // URL.revokeObjectURL(objectURL)
               this.$refs.modalPdf.open()
               // this.$bvModal.show('modal-cetak-izin-lama')
               this.loadingPdf = false
            },
            () => {
               this.loadingPdf = false
            },
         )
      },
      onCetakNib(nib) {
         this.loadingPdf = true
         this.cetakNib(nib).then(
            res => {
               const blob = new Blob([res.data])
               this.pdf = URL.createObjectURL(blob)
               // URL.revokeObjectURL(objectURL)
               this.$refs.modalPdf.open()
               this.loadingPdf = false
            },
            () => {
               this.loadingPdf = false
            },
         )
      },
      onCetak() {
         if (!this.isFilterOpen) {
            this.$toast.error('Aktifkan filter untuk mencetak PDF')
            return
         }
         this.loadingPdf = true
         const params = {}
         const tglAwal = this.formatDate(this.filter.tanggal_awal)
         const tglAkhir = this.formatDate(this.filter.tanggal_akhir)
         if (tglAwal) params.tanggal_awal = tglAwal
         if (tglAkhir) params.tanggal_akhir = tglAkhir
         if (this.filter.jenis !== null) {
            params.jenis = this.filter.jenis
         }
         if (this.filter.kewenangan !== null) {
            params.kewenangan = this.filter.kewenangan
         }
         if (this.filter.skala !== null) {
            params.skala = this.filter.skala
         }
         if (this.filter.resiko !== null) {
            params.resiko = this.filter.resiko
         }
         if (this.filter.status !== null) {
            params.status = this.filter.status
         }
         if (this.filter.sektor !== null) {
            params.sektor = this.filter.sektor
         }
         if (this.filter.perusahaan_daerah_id !== null) {
            params.perusahaan_daerah_id = this.filter.perusahaan_daerah_id
            params.daerah_mode = this.filter.daerah_mode
         }
         if (this.searchTerm) {
            params.search = this.searchTerm
         }
         this.cetakListIzinRba(params).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      formatDate(date) {
         if (!date) return null
         const d = new Date(date)
         const year = d.getFullYear()
         const month = String(d.getMonth() + 1).padStart(2, '0')
         const day = String(d.getDate()).padStart(2, '0')
         return `${year}-${month}-${day}`
      },
      onDetailProyek(idProyek) {
         this.setIdProyek(idProyek)
         this.$bvModal.show('modal-detail')
      },

      // VUE GOOD TABLE
      async loadItems() {
         this.loading = true
         await this.getData(this.serverParams)
      },
      updateParams(newProps) {
         // eslint-disable-next-line prefer-object-spread
         this.serverParams = Object.assign({}, this.serverParams, newProps)
      },
      onPageChangePagination(page) {
         this.updateParams({ page })
         this.loadItems()
      },
      onPerPageChangePagination(perPage) {
         this.updateParams({ perPage, page: 1 })
         this.loadItems()
      },
      onColumnFilter(params) {
         this.updateParams({ ...params, page: 1 })
         this.loadItems()
      },
      onSearch: debounce(function search(params) {
         this.serverParams.search = params
         this.serverParams.page = 1
         this.loadItems()
      }, 500),
      onFilterOpen() {
         this.inputSearch = false
         this.isFilterOpen = true
         this.searchTerm = ''
         this.filter.tanggal_awal = new Date(new Date().getFullYear(), 0, 1)
         this.filter.tanggal_akhir = new Date()
         this.onFilter()
         console.log('open')
      },
      onFilterClose() {
         this.inputSearch = true
         this.isFilterOpen = false
         console.log('close')
      },
      onFilter() {
         this.serverParams.page = 1
         setTimeout(() => {
            this.updateParams({ filter: this.filter })
            this.loadItems()
         }, 100)
      },
      onSubmit() {
         return null
      },
      onRunDokumen(data) {
         this.loadingPdf = true

         const param = {
            id_permohonan_izin: data.id_permohonan_izin,
            id_permohonan: data.id_permohonan,
            id_proyek: data.id_proyek,
            id_lic: data.id_lic,
         }

         this.runScrapDokumen(param).then(
            () => {
               this.$toast.success('Berhasil')
               this.loadingPdf = false
            },
            () => {
               this.loadingPdf = false
            },
         )
      },
      onRunScrap(data) {
         this.loadingPdf = true

         this.getNib({ id_permohonan_izin: data.id_permohonan_izin, id_proyek: data.id_proyek }).then(
            res => {
               this.runScrap(res.nib).then(
                  () => {
                     this.$toast.success('Berhasil')
                     this.loadingPdf = false
                  },
                  () => {
                     this.loadingPdf = false
                  },
               )
            },
            () => {
               this.loadingPdf = false
            },
         )
      },
   },
}
</script>

<template>
   <div>
      <b-card-code title="Data Perizinan RBA">
         <!-- search input -->
         <b-row>
            <!-- TOOLBAR -->
            <b-col cols="12" md="6">
               <b-form @submit.stop.prevent>
                  <div class="d-flex align-items-center justify-content-end">
                     <b-form-input
                        v-model="searchTerm"
                        class="d-inline-block mb-1"
                        placeholder="Search..."
                        autocomplete="off"
                        type="text"
                        aria-label="Search"
                        @input="onSearch"
                     />
                  </div>
               </b-form>
            </b-col>
            <b-col cols="12" md="6">
               <div class="d-flex justify-content-end">
                  <b-button-group class="mb-1">
                     <b-button
                        v-b-toggle.collapse-filter
                        variant="outline-secondary"
                        size="sm"
                     >
                        <feather-icon icon="FilterIcon" />
                     </b-button>
                     <b-button
                        v-b-tooltip.hover.top="'Cetak PDF'"
                        variant="outline-secondary"
                        size="sm"
                        @click="onCetak()"
                     >
                        <feather-icon icon="FileTextIcon" />
                     </b-button>
                     <b-button
                        variant="outline-secondary"
                        size="sm"
                        @click="loadItems()"
                     >
                        <feather-icon icon="RefreshCwIcon" />
                     </b-button>
                     <b-dropdown
                        variant="outline-secondary"
                        right
                        text="Menu"
                        size="sm"
                     >
                        <b-dropdown-item @click="onFilter()">
                           Filter
                        </b-dropdown-item>
                        <b-dropdown-item @click="loadItems()">
                           Refresh
                        </b-dropdown-item>
                     </b-dropdown>
                  </b-button-group>
               </div>
            </b-col>

            <b-col>
               <b-collapse
                  id="collapse-filter"
                  class="mt-2"
                  @onLeave="onFilterOpen"
                  @onEnter="onFilterClose"
                  @shown="onFilterOpen"
                  @hide="onFilterClose"
               >
                  <b-card class="border">
                     <b-row>
                        <b-col md="3">
                           <b-form-group label="Tanggal Awal" label-for="tanggal-awal">
                              <datepicker
                                 v-model="filter.tanggal_awal"
                                 input-class="datepicker-here form-control"
                                 minimum-view="date"
                                 maximum-view="year"
                                 format="dd MMMM yyyy"
                                 :language="filterDateLang"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Tanggal Akhir" label-for="tanggal-akhir">
                              <datepicker
                                 v-model="filter.tanggal_akhir"
                                 input-class="datepicker-here form-control"
                                 minimum-view="date"
                                 maximum-view="year"
                                 format="dd MMMM yyyy"
                                 :language="filterDateLang"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Skala Usaha" label-for="skala">
                              <v-select
                                 id="skala"
                                 v-model="filter.skala"
                                 :options="options.skala"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Skala..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Risiko Usaha" label-for="resiko">
                              <v-select
                                 id="resiko"
                                 v-model="filter.resiko"
                                 :options="options.resiko"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Resiko..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>

                     <b-row class="mt-2">
                        <b-col md="3">
                           <b-form-group label="Jenis" label-for="jenis">
                              <v-select
                                 id="jenis"
                                 v-model="filter.jenis"
                                 :options="options.jenis"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Jenis..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Kewenangan" label-for="kewenangan">
                              <v-select
                                 id="kewenangan"
                                 v-model="filter.kewenangan"
                                 :options="options.kewenangan"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Kewenangan..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Status Izin" label-for="status">
                              <v-select
                                 id="status"
                                 v-model="filter.status"
                                 :options="options.status"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Status..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Sektor" label-for="sektor">
                              <v-select
                                 id="sektor"
                                 v-model="filter.sektor"
                                 :options="options.sektor"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Sektor..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>

                     <b-row class="mt-2">
                        <b-col md="6">
                           <b-form-group label="Daerah" label-for="daerah">
                              <b-form-radio-group
                                 id="daerah-mode"
                                 v-model="filter.daerah_mode"
                                 :options="[{ text: 'Kecamatan', value: 'kecamatan' }, { text: 'Kelurahan/Desa', value: 'kelurahan' }]"
                                 class="mb-1"
                                 @change="filter.perusahaan_daerah_id = null; onFilter()"
                              />
                              <v-select
                                 id="daerah"
                                 v-model="filter.perusahaan_daerah_id"
                                 :options="optionsDaerah"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Daerah..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>
                  </b-card>
               </b-collapse>
            </b-col>
         </b-row>

         <!-- table -->
         <vue-good-table
            ref="goodTable"
            mode="remote"
            :columns="columns"
            :rows="myData"
            :total-rows="myCount"
            :is-loading.sync="loading"
            :line-numbers="true"
            :pagination-options="{
               enabled: true,
               mode: 'pages',
            }"
            :search-options="{
               enabled: true,
               externalQuery: searchTerm,
            }"
            @on-column-filter="onColumnFilter"
            @on-search="onSearch"
         >
            <template slot="table-row" slot-scope="props">
               <!-- Column: Name -->
               <span v-if="props.column.field == 'dokumen'">
                  <b>{{ props.row.nama_dokumen }}</b>
                  <hr>
                  <small>Terbit :
                     {{
                        props.row.tgl_terbit_dokumen | moment("DD-MM-YYYY")
                     }}</small>
               </span>

               <span v-if="props.column.field == 'nib'">
                  <b>{{ props.row.nama_perusahaan }}</b>
                  <br>
                  <hr>
                  <b class="text-primary">{{ props.row.nib }}</b>
                  <br>
                  <small>{{
                     jenisPerusahaan(props.row.jenis_perusahaan)
                  }}</small>
                  <hr>
                  <small>{{
                     skalaUsaha(props.row.kd_skala_usaha_final)
                  }}</small>
               </span>

               <span v-if="props.column.field == 'alamat'">
                  <small>
                     <b>{{ props.row.nama_proyek }}</b>
                  </small>
                  <hr>
                  <small>{{ props.row.alamat_usaha }}</small>
                  <br>
                  <small class="font-weight-bold font-italic">
                     Kel/Desa:
                     <b>{{ props.row.kelurahan }}</b>
                  </small>
                  <br>
                  <small class="font-weight-bold font-italic">
                     Kec:
                     <b>{{ props.row.kecamatan }}</b>
                  </small>
               </span>

               <span v-if="props.column.field == 'status'">
                  <center>
                     <small :class="kewenanganColor(props.row.kewenangan)">{{
                        kewenanganIzin(props.row.kewenangan)
                     }}</small>
                  </center>
                  <hr>
                  <center>
                     <b-badge variant="secondary" class="mt-50">
                        <small>{{ statusIzin(props.row.status_respon) }}</small>
                     </b-badge>
                  </center>
               </span>

               <span v-if="props.column.field == 'usaha'">
                  <b>KBLI : {{ props.row.kbli }}</b>
                  <br>
                  <small>{{ props.row.nama_kbli }}</small>
                  <hr>
                  <small>
                     Sektor :
                     <b class="text-danger">{{
                        sektorCode(props.row.sektor)
                     }}</b>
                  </small>
                  <hr>
                  <small>
                     Resiko :
                     <b class="text-danger">{{
                        statusResiko(props.row.kd_resiko)
                     }}</b>
                  </small>
                  <hr>
                  <small>
                     Modal :
                     <b class="text-danger">{{
                        props.row.jumlah_investasi | formatNumber
                     }}</b>
                  </small>
                  <hr>
                  <small>
                     Skala :
                     <b class="text-danger">{{
                        skalaUsaha(props.row.kd_skala_usaha)
                     }}</b>
                  </small>
                  <br>
                  <small>{{ props.row.id_proyek }}</small>
               </span>

               <span v-if="props.column.field == 'action'">

                  <b-dropdown
                     variant="relief-secondary"
                     right
                     text="Menu"
                     size="sm"
                     block
                  >
                     <b-dropdown-item @click="onDetailProyek(props.row.id_proyek)">
                        Detail
                     </b-dropdown-item>
                     <b-dropdown-item @click="onCetakIzin(props.row.id_permohonan_izin)">
                        Cetak Dokumen
                     </b-dropdown-item>
                     <b-dropdown-item @click="onCetakNib(props.row.nib)">
                        Cetak NIB
                     </b-dropdown-item>
                     <b-dropdown-item @click="onRunDokumen(props.row)">
                        Update Dokumen
                     </b-dropdown-item>
                     <b-dropdown-item @click="onRunScrap(props.row)">
                        Update Data
                     </b-dropdown-item>
                  </b-dropdown>

               </span>

               <!-- Column: Common -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
            </template>

            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
               <pagination-custom
                  :total="props.total"
                  :page-length="pageLength"
                  :page-options="pageOptions"
                  :page="serverParams.page"
                  :page-changed="props.pageChanged"
                  :per-page-changed="props.perPageChanged"
                  @update:page="onPageChangePagination"
                  @update:perpage="onPerPageChangePagination"
               />
            </template>
         </vue-good-table>
      </b-card-code>

      <b-modal
         id="modal-detail"
         scrollable
         size="xl"
         hide-footer
         title="Bidang Usaha Detail"
      >
         <ProyekDetail ref="proyekDetail" />
      </b-modal>

      <sweet-modal
         ref="modalPdf"
         modal-theme="light"
         overlay-theme="dark"
         width="80%"
      >
         <!-- <pdf :src="pdf" /> -->
         <div style="height: 70vh">
            <vue-pdf-app :pdf="pdf" />
         </div>
      </sweet-modal>
   </div>
</template>

<style scoped>
.borderless > tr > td {
   border: none;
   padding: 0em;
}
table > tbody > tr > td > span > hr {
   margin-top: 0rem;
   margin-bottom: 0rem;
}

.nowrap {
   white-space: nowrap;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
